import classNames from 'classnames';

import { Call } from '@/icons/index';

import styles from './LinkNumbers.module.scss';

const SplitNumbers = ({
  numbers,
  isNotLink,
  isTel,
  className,
  dark = false,
  isLight,
}) => {
  const LINK_CONTAINER_CLASS = 'link-numbers';
  const LINK_ITEM_CLASS = 'link-numbers__item';

  const renderNumber = (item, index) => {
    return (
      <span
        className={classNames([
          styles[LINK_ITEM_CLASS],
          { [styles.dark]: dark },
        ])}
        key={index}
        itemScope
        itemType='http://schema.org/Text'
      >
        {item}
      </span>
    );
  };

  if (isNotLink) {
    return (
      <div
        className={classNames([
          styles[LINK_CONTAINER_CLASS],
          className,
          { [styles['link-numbers--light']]: isLight },
        ])}
        itemScope
        itemType='http://schema.org/Property'
      >
        {[...numbers].map(renderNumber)}
        {isTel && (
          <span
            className={classNames([
              styles[LINK_ITEM_CLASS],
              { [styles.dark]: dark },
            ])}
          >
            <Call />
          </span>
        )}
      </div>
    );
  }

  return (
    <a
      href={`tel:${numbers}`}
      className={classNames([
        styles[LINK_CONTAINER_CLASS],
        className,
        { [styles['link-numbers--light']]: isLight },
      ])}
      itemScope
      itemType='http://schema.org/Thing'
    >
      {[...numbers].map(renderNumber)}
      {isTel && (
        <span
          className={classNames([
            styles[LINK_ITEM_CLASS],
            { [styles.dark]: dark },
          ])}
        >
          <Call />
        </span>
      )}
    </a>
  );
};

export default SplitNumbers;
